import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import { Layout } from '../components/common'
import { MetaData } from '../components/common/meta'
import HeroFullScreenPhoto from '../components/sections/hero-full-screen-photo'
import Partnerships from '../components/common/partnerships'
import OurPartners from '../components/sections/our-partners'
import Testimonials from '../components/sections/testimonials-static'
import WhyThinkPlus from '../components/sections/why-think-plus'
import SectionHeader from '../components/common/section-header'
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, } from 'react-accessible-accordion';
import ContactForm from '../components/sections/contact-form'

import '../styles/pages/page-landingpage.scss'
import { faqShopify } from '../utils/schema/faq'
import { shopify as servicesSchema } from '../utils/schema/services'

const pageEshopshoppify = ({ location }) => {
  const data = useStaticQuery(graphql`{
		ghostPage: ghostPage(tags: {elemMatch: {name: {eq: "#page-eshopshopify"}}}) {
			...GhostPageFields
		}
		hero: file(relativePath: {eq: "hero/hero-shopify.jpg"}) {
			childImageSharp {
				gatsbyImageData(quality: 90, layout: FULL_WIDTH)
			}
		}
		caseStudy_aek: file(relativePath: {eq: "eshopshopify/tp-casestudy-aek.png"}) {
			childImageSharp {
				gatsbyImageData(width: 664, layout: CONSTRAINED)
			}
		}
		caseStudy_apoella: file(relativePath: {eq: "eshopshopify/tp-casestudy-apoella.png"}) {
			childImageSharp {
				gatsbyImageData(width: 664, layout: CONSTRAINED)
			}
		}
		caseStudy_bioaroma: file(relativePath: {eq: "eshopshopify/tp-casestudy-bioaroma.png"}) {
			childImageSharp {
				gatsbyImageData(width: 664, layout: CONSTRAINED)
			}
		}
		caseStudy_desunglasses: file(relativePath: {eq: "eshopshopify/tp-casestudy-desunglasses.png"}) {
			childImageSharp {
				gatsbyImageData(width: 664, layout: CONSTRAINED)
			}
		}
		caseStudy_loumidis: file(relativePath: {eq: "eshopshopify/tp-casestudy-loumidis.png"}) {
			childImageSharp {
				gatsbyImageData(width: 664, layout: CONSTRAINED)
			}
		}
	}
	`)
	const page = data.ghostPage

  useEffect(() => {
    let packagesHeaders = document.querySelectorAll('.packages__headers .package__description')
    let packagesDetails = document.querySelectorAll('.package__item .package__description')

    let showDetails = (pack) => {
      pack.classList.add('show')
      pack.querySelector('button').style.display = 'none'
    }

    let hideDetails = (pack) => {
      pack.classList.remove('show')
      pack.querySelector('button').style.display = 'initial'
    }

    let handleGroup = (group) => {
      group.forEach(pack => {
        pack.querySelector('button').addEventListener('click', () => {
          group.forEach(pack => hideDetails(pack))
          !pack.classList.contains('show') && showDetails(pack)
        })
      })
    }

    handleGroup(packagesHeaders)
    handleGroup(packagesDetails)
  })

  return <>
      <MetaData
        data={data}
        location={location}
        type="website"
      />
      <Helmet>
        <style type="text/css">{`${page.codeinjection_styles}`}</style>
        <script type="application/ld+json">{JSON.stringify(faqShopify)}</script>
        <script type="application/ld+json">{JSON.stringify(servicesSchema)}</script>
      </Helmet>
      <Layout viewport={'full'}>
        <article className="landing-page">
          <HeroFullScreenPhoto
            heroImage={data.hero.childImageSharp.gatsbyImageData}
            heroContent={
              `<img src="/images/logos/shopify-experts-2.svg" alt="Shopify Experts | Think Plus - Advertising" />
              <div class="landing-page__heading">
                <h1>ΚΑΤΑΣΚΕΥΗ ESHOP</h1>
                <h2>H Λύση σας στο eCommerce</h2>
              </div>
              <div class="landing-page__heading-cta">
                <p class="h6 dec-element--line-horizontal">Επικοινωνήστε μαζί μας +30 210 6101478 <a href="tel: +302106101478" class="btn__theme ml-md-3 mt-3 mt-md-0">Καλέστε μας</a></p>
                <p class="h6 dec-element--line-horizontal">Ή συμπληρώστε τα πεδία της φόρμας για να επικοινωνήσουμε άμεσα μαζί σας <a href="#contact_form_section" class="btn__theme ml-md-3 mt-3 mt-md-0">Φόρμα Επικοινωνίας</a></p>
              </div>`
            }
          />
          <section className="landing-page__info background__theme text-align-center">
            <div className="container medium">
              <div className="row">
                <div className="col mb-5">
                  <h2>Ψάχνετε για κατασκευή eshop; <br/>Μας εμπιστεύονται ήδη τα μεγαλύτερα <br />brands που επιλέγουν Shopify!</h2>
                  <p className="h6">Οι τεχνικές και εικαστικές μας δεξιότητες σε συνδυασμό με την πολυετή εμπειρία στο σχεδιασμό και προώθηση ενός άκρως επιτυχημένου shopify eshop, αποτελούν τη καλύτερη εγγύηση για την επιτυχία στο ecommerce!</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <h3 className="h6">
                    <strong className="h2">No. 1</strong> <br />
                    E-Commerce πλατφόρμα παγκοσμίως
                  </h3>
                </div>
                <div className="col-md-4">
                  <h3 className="h6">
                    Περισσότερες από <br />
                    <strong className="h2">1.000.000</strong> <br />
                    επιχειρήσεις σε 175 χώρες εμπιστεύονται το Shopify
                  </h3>
                </div>
                <div className="col-md-4">
                  <h3 className="h6">
                    <strong className="h2">140,76 δις.€</strong> <br />
                    Συνολικός τζίρος μέχρι σήμερα
                  </h3>
                </div>
              </div>
            </div>
          </section>
          <section className="what-we-offer" id="what_we_offer" style={{paddingBottom: '0'}}>
            <header className="container medium text-align-center">
              <h2 className="dec-header--underline">Μεγάλο κόστος;</h2>
              <div className="h4">
                Φυσικά και ΟΧΙ! <br />
                Αποκτήστε το βασικό πακέτο μας στα 2.000€. <br />
                Πλήρες &amp; Λειτουργικό Σύστημα E-Shop με shopify. <br />
                Τι συμπεριλαμβάνει:
              </div>
            </header>
            <div className="what-we-offer__packages background__theme">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="packages__headers packages__container">
                      <div className="package__header">
                        <h3 className="text-align-center px-3"><strong>STARTER</strong> PACKAGE</h3>
                        <div className="package__description first-row-item">
                          <p className="excerpt__hide-more">Ιδανικό για επιχειρηματίες που θέλουν να γνωρίσουν το κόσμο του ηλεκτρονικού εμπορίου με προσοχή και φειδώ... <button className="link--active">Περισσότερα</button></p>
                          <span className="package__description-full">
                            <p>Ιδανικό για επιχειρηματίες που θέλουν να γνωρίσουν το κόσμο του ηλεκτρονικού εμπορίου με προσοχή και φειδώ. Για startup εταιρείες που θέλουν ένα πολύ γρήγορο και άμεσο ξεκίνημα. Για ιδιοκτήτες καταστημάτων που επιθυμούν ένα άρτιο eshop με όλες τις βασικές λειτουργίες, εξοικονομώντας όμως κεφάλαια για τη διαφήμιση αυτού. Στη Think Plus έχουμε μάθει να συνεργαζόμαστε επιτυχώς με όλα τα μεγέθη επιχειρήσεων. Από τις μικρές επιχειρήσεις που αποτελούν τη ραχοκοκαλιά της Ελληνικής οικονομίας, μέχρι τις μεγάλες πολυεθνικές. Κάθε πελάτης είναι ξεχωριστός, όπως και οι ανάγκες του και στη Think Plus αντιλαμβανόμαστε πλήρως αυτή τη διαφορετικότητα. Δεν χρειάζεται να ξοδέψετε δεκάδες χιλιάδες ευρώ για να εισέλθετε στο κόσμο του ηλεκτρονικού εμπορίου, όπως επίσης τα ηλεκτρονικά μας καταστήματα δεν έχουν "ταβάνια, σύνορα &amp; περιορισμούς"... Με λίγα λόγια επενδύστε 2000 ευρώ στη κατασκευή του καταστήματος σας, ελάτε να σχεδιάσουμε μαζί τη προώθησή του (γιατί κανένα eshop δεν πουλάει - όσο ακριβό και αν είναι  - αν δεν προωθείται) και αφήστε τις πωλήσεις του να σας δείξουν πως θέλετε να συνεχίσετε. Και μη ξεχνάτε αν αύριο οι ανάγκες του eshop σας μεγαλώσουν, δεν το "πετάμε" και σας προτείνουμε/επιβάλουμε ένα καινούργιο. Όχι. Εξελίσσουμε το ήδη υπάρχον.</p>
                          </span>
                          <strong className="package__delivery">Παράδοση σε 7 ημέρες.</strong>
                          <div className="package-bar"><div className="progress-bar starter" /></div>
                        </div>
                      </div>
                      <div className="package__header">
                        <h3 className="text-align-center px-3"><strong>ADVANCED</strong> PACKAGE</h3>
                        <div className="package__description middle-row-item">
                          <p className="excerpt__hide-more">Προσαρμογή του σχεδιαστικού στην εταιρική και προϊοντική ταυτότητα της επιχείρησης αποκλειστικά σύμφωνα...  <button className="link--active">Περισσότερα</button></p>
                          <span className="package__description-full">
                            <p>Είστε μία επιχείρηση που έχει ήδη κάνει τα πρώτα βήματα στο ηλεκτρονικό εμπόριο και πλέον θέλει ένα eshop κατασκευασμένο με το καλύτερο διαχειριστικό;
                            Είστε ένας επιχειρηματίας που αντιλαμβάνεται ότι ζούμε στην εποχή του customized &amp; tailor-made marketing;
                            Είστε ένας φιλόδοξος επιχειρηματίας που επιθυμεί να ανταγωνιστεί από πλεονεκτική θέση το διεθνή ανταγωνισμό;
                            Τότε θέλετε ένα Shopify κομμένο και ραμμένο στα μέτρα σας.
                            Η ομάδα μας γνωρίζοντας τα στοιχεία που διαφοροποιούν τις σύγχρονες γενιές και ιδιαίτερα τη γενιά Ζ η οποία αποτελεί και το μεγάλο ποσοστό των πελατών εν γένει του ηλεκτρονικού εμπορίου,  γεμάτη ενέργεια και δημιουργικότητα και σε απόλυτη ευθυγράμμιση με το digital transformation, δημιουργεί μοναδικά eshops πλήρως εναρμονισμένα με τις ανάγκες του σήμερα.
                            Ένα eshop αρτιότατο τεχνικά και εικαστικά με το design και τις λειτουργίες του πλήρως διαμορφωμένα βάσει των δικών σας θέλω αλλά και των σύγχρονων επιταγών για ένα επιτυχημένο eshop. 
                            Όπως ακριβώς λοιπόν θέλετε το φυσικό σας κατάστημα κατά τη σχεδίαση να ξεχωρίζει από τα υπόλοιπα, προσελκύοντας περισσότερους πελάτες, δεν θα μπορούσε παρά να συμβαίνει ακριβώς το ίδιο και για το eshop σας. Στη Think Plus είμαστε σε θέση να καλύψουμε κάθε τεχνική και εικαστική σας ανάγκη, δημιουργώντας και προωθώντας ένα άκρως δημοφιλές και επιτυχημένο eshop.
                            Aν δεν έχετε πειστεί ακόμη, ρίξτε μια ματιά στα έργα μας.</p>
                          </span>
                          <strong className="package__delivery">Παράδοση σε 20 ημέρες.</strong>
                          <div className="package-bar"><div className="progress-bar advanced" /></div>
                        </div>
                      </div>
                      <div className="package__header">
                        <h3 className="text-align-center px-3"><strong>PLUS</strong> PACKAGE</h3>
                        <div className="package__description">
                          <p className="excerpt__hide-more">Εάν είστε ιδιαίτερα έμπειρος επιχειρηματίας στο χώρο του ηλεκτρονικού εμπορίου, έχοντας πλέον διακρίνει τα μειονεκτήματα...  <button className="link--active">Περισσότερα</button></p>
                          <span className="package__description-full">
                            <p>Εάν είστε ένας ιδιαίτερα έμπειρος επιχειρηματίας στο χώρο του ηλεκτρονικού εμπορίου, έχοντας πλέον διακρίνει τα μειονεκτήματα του υπάρχοντος eshop σας και επιθυμείτε τη καλύτερη παγκοσμίως λύση γι αυτό.
                            Εάν θέλετε ένα eshop που θα κάνει "πρωταθλητισμό", θα διεκδικήσει βραβεία και κυρίως μεγάλο μερίδιο αγοράς έναντι του ανταγωνισμού.
                            Εάν είστε ένας επιχειρηματίας που αντιλαμβάνεστε ότι όπως ακριβώς επενδύετε στο φυσικό σας κατάστημα, έτσι θα πρέπει να επενδύσετε και στο ηλεκτρονικό σας κατάστημα.
                            Τότε πάμε να κάνουμε την διαφορά μαζί...!!
                            Ξεχάστε κάθε συμβατικό eshop και αφήστε μας να σας προτείνουμε και να υλοποιήσουμε για εσάς όλες εκείνες τις ξεχωριστές λειτουργίες που βλέπετε σε eshops του εξωτερικού με εκατομμύρια ευρώ τζίρου. Το αρτιότατο τεχνικό τμήμα της Think Plus, με εθνικές και διεθνείς διακρίσεις σε υπηρεσίες development, μαζί με τους έμπειρους συναδέλφους σε design, UI &amp; UX είναι σε θέση να δημιουργήσει για εσάς οτιδήποτε επιθυμείτε.</p>
                          </span>
                          <strong className="package__delivery">Παράδοση σε 60 ημέρες.</strong>
                          <div className="package-bar"><div className="progress-bar plus" /></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="packages__container">
                      {/* Starter Package */}
                      <div className="package__item">
                        <h3 className="text-align-center"><strong>STARTER</strong> PACKAGE</h3>
                        <div className="package__details">
                          <p className="package__price text-align-center"><small>από</small> 2000€</p>
                          <div className="package__contents">
                            <h4 className="h5">Προϊόντικός κατάλογος</h4>
                            <div className="package__description" id="starter_catalog">
                              <p>Κατηγοριοποίηση προϊόντων σε απεριόριστα επίπεδα κατηγοριών και υποκατηγοριών (collections)<span className="excerpt__full">.</span><span className="excerpt__hide-more" aria-hidden="true">...</span></p>
                              <span className="package__description-full">
                                <p>Αναλυτική παρουσίαση κάθε προϊόντος ή υπηρεσίας με απεριόριστο αριθμό φωτογραφιών, κατηγορία (collection), SKU, Barcode, τύπος προϊόντος, προμηθευτής, περιγραφή, κόστος προϊόντων, αρχική τιμή και τιμή έκπτωσης. Οποιαδήποτε άλλη προδιαγραφή μπορεί να συμπεριληφθεί στην περιγραφή.</p>
                                <p>Πολλαπλή κατηγοριοποίηση προϊόντων εντελώς αυτοματοποιημένα ή χειροκίνητα.</p>
                                <p>Διαχειριστικό σύστημα και Mobile Application του ηλεκτρονικού καταστήματος για την διαχείριση των παραγγελιών, προϊόντων και πελατών.</p>
                                <p>Πλήρη διαχείριση των προϊόντων με εύκολο στην χρήση περιβάλλον για προσθήκες, αφαιρέσεις και κάθε είδους τροποποιήσεις.</p>
                                <p>Κατασκευή e-shop με όλα τα φίλτρα πλοήγησης (tags).</p>
                                <p>«Collections(συλλογές)» παρουσίασης επιλεγμένων προϊόντων στην κεντρική σελίδα.</p>
                                <p>Λειτουργία σχετικών προϊόντων (related products).</p>
                                <p>Λειτουργία προϊόντων σε διαφορετικά variations (χρώμα, μέγεθος,...)</p>
                                <p>Λειτουργία αρχικής τιμής και τιμή έκπτωσης για πραγματοποίηση εκπτωτικής πολιτικής.</p>
                                <p>Εισαγωγή προϊόντων μέσω αρχείων CSV.</p>
                                <p>Διαφορετικά επίπεδα διαθεσιμότητας &amp; stock management ανάλογα με τις ανάγκες σας.</p>
                              </span>
                              <button className="link--active">Περισσότερα</button>
                            </div>
                          </div>
                          <div className="package__contents">
                            <h4 className="h5">Υπηρεσίες Σχεδιασμού</h4>
                            <div className="package__description">
                              <p>Προσαρμογή του σχεδιαστικού στην εταιρική και προϊοντική ταυτότητα της επιχείρησης αποκλειστικά σύμφωνα<span className="excerpt__full"> με τις δυνατότητες του theme (mobile first design &amp; responsive).</span><span className="excerpt__hide-more" aria-hidden="true">...</span></p>
                              <span className="package__description-full">
                                <p>Ο πελάτης μπορεί να επέμβει άμεσα στην επιλογή προϊόντων στο καλάθι ή απευθείας στην ολοκλήρωση αγοράς.</p>
                                <p>Δυνατότητα παραγγελίας χωρίς εγγραφή (guest checkout).</p>
                                <p>Εταιρική παρουσίαση με πλήρη ανάλυση του ιστορικού της εταιρίας, δραστηριοτήτων, οικονομικών μεγεθών, αποκλειστικά σύμφωνα με τις δυνατότητες του theme.</p>
                                <p>Αναζήτηση (full text) στα ελληνική ή αγγλικά και σύνθετη αναζήτηση.</p>
                                <p>Κατασκευή e-shop με δυναμική ενότητα διαχείρισης εταιρικών και προϊοντικών νέων (blog).</p>
                              </span>
                              <button className="link--active">Περισσότερα</button>
                            </div>
                          </div>
                          <div className="package__contents">
                            <h4 className="h5">Υπηρεσίες Διαχείρισης</h4>
                            <div className="package__description">
                              <p>Αυτόματη ενημέρωση του διαχειριστή και μέσω email για κάθε παραγγελία<span className="excerpt__full">.</span><span className="excerpt__hide-more" aria-hidden="true">...</span></p>
                              <span className="package__description-full">
                                <p>Ενημέρωση πελάτη μέσω email και δωρεάν sms για κάθε αλλαγή της κατάστασης της παραγγελίας του.</p>
                                <p>Επίπεδα πολλαπλής πρόσβασης στο διαχειριστικό περιβάλλον με διαφορετικά δικαιώματα.</p>
                                <p>Προσαρμογή εξόδων αποστολής και φόρων για όλες τις χώρες.</p>
                                <p>Οικονομικά στατιστικά σχετικά με την επιχείρησή σας χρησιμοποιώντας τις αναφορές.</p>
                              </span>
                              <button className="link--active">Περισσότερα</button>
                            </div>
                          </div>
                          <div className="package__contents">
                            <h4 className="h5">Τεχνικές Διασυνδέσεις &amp; Ασφάλεια</h4>
                            <div className="package__description">
                              <p>Πλήρης λίστα από offline τρόπους πληρωμής: Τραπεζική κατάθεση, Μεταφορά χρημάτων μέσω e-banking<span className="excerpt__full">, Αντικαταβολή, Παραλαβή από κατάστημα κ.λ.π.</span><span className="excerpt__hide-more" aria-hidden="true">...</span></p>
                              <span className="package__description-full">
                                <p>Πλήρης υποστήριξη online πληρωμών: Πιστωτικές κάρτες, Χρεωστικές κάρτες, Paypal Express.</p>
                                <p>Πλήρης HTTPS/SSL υποστήριξη με δωρεάν certificate.</p>
                                <p>Προστασία με κωδικό στην πρόσβαση της διαχείρισης.</p>
                                <p>Υποστήριξη πολιτικών GDPR σε επίπεδο κατασκευής eshop.</p>
                                <p>Αυτόματο σύστημα fraud analysis στις συναλλαγές με IP Location.</p>
                                <p>24/7 Support στα τεχνικά θέματα που αφορούν το Shopify με τηλέφωνο, email και live chat.</p>
                                <p>Hosting με απεριόριστο bandwidth και online storage.</p>
                              </span>
                              <button className="link--active">Περισσότερα</button>
                            </div>
                          </div>
                          <div className="package__contents">
                            <h4 className="h5">Υπηρεσίες Marketing</h4>
                            <div className="package__description">
                              <p>Δυνατότητα εγγραφής του επισκέπτη για newsletters &amp; email campaigns<span className="excerpt__full">.</span><span className="excerpt__hide-more" aria-hidden="true">...</span></p>
                              <span className="package__description-full">
                                <p>Σύστημα για κουπόνια με δυνατότητα shareable link &amp; δωροκάρτες.</p>
                                <p>Υπηρεσία αποστολής email Abandoned Cart Recovery.</p>
                                <p>Επιλογή λέξεων κλειδιών &amp; meta description για τις σελίδες κατηγοριών και προϊόντων.</p>
                                <p>Επιλογή λέξεων κλειδιών &amp; meta description για τις σελίδες περιεχομένου.</p>
                              </span>
                              <button className="link--active">Περισσότερα</button>
                            </div>
                          </div>
                        </div>
                        <div className="package__cta">
                          <a href="mailto:info@think-plus.gr?subject=Shopify Starter Package" className="btn btn__theme">Επιλογή</a>
                        </div>
                      </div>
                      {/* Advanced Package */}
                      <div className="package__item package--active">
                        <h3 className="text-align-center"><strong>ADVANCED</strong> PACKAGE</h3>
                        <div className="package__details">
                          <p className="package__price text-align-center"><small>από</small> 4000€</p>
                          <div className="package__contents">
                            <h4 className="h5 mb-4">όλα του STARTER PACKAGE +</h4>
                            <div className="checkmarks checkmarks--theme mb-5">
                              <p>Προσαρμογή του σχεδιαστικού στην εταιρική και προϊοντική ταυτότητα της επιχείρησης custom (mobile first design &amp; responsive)</p>
                              <p>Σύστημα σύγκρισης προϊόντων &amp; product reviews</p>
                              <p>Διαδικασία εγγραφής μέλους - πελάτη (Registration &amp; Sign In)</p>
                              <p>Wish list (καλάθι αγαπημένων προϊόντων)</p>
                              <p>Κατασκευή e-shop με όλα τα σύγχρονα φίλτρα πλοήγησης (αυτόματα και tags)</p>
                              <p>Υπηρεσία αποστολής κωδικού στο email του πελάτη σε περίπτωση απώλειας του κωδικού</p>
                              <p>Βελτιστοποιημένη διαδικασία ολοκλήρωσης της αγοράς και του user experience του πελάτη</p>
                              <p>Δυνατότητα του πελάτη να βλέπει την καρτέλα του και το ιστορικό των παραγγελιών του</p>
                            </div>
                            <strong className="mb-3">Σύνδεση με</strong>
                            <ul className="list--dot">
                              <li>Google Analytics, Google Search Console και παροχή Google Sitemap</li>
                              <li>Google Merchant και product feed για Shopping Ads</li>
                              <li>Facebook &amp; Instagram και δημιουργία Product Catalog</li>
                              <li>site σύγκρισης τιμών Skroutz, Best Price &amp; Glami</li>
                              <li>εφαρμογές Newsletter Mailchimp, Klaviyo, κτλ και αυτόματη ανανέωση λιστών</li>
                              <li>Facebook Messenger &amp; Support Chat</li>
                            </ul>
                          </div>
                        </div>
                        <div className="package__cta">
                          <a href="mailto:info@think-plus.gr?subject=Shopify Advanced Package" className="btn btn__theme--inverted">Επιλογή</a>
                        </div>
                      </div>
                      {/* Plus Package */}
                      <div className="package__item">
                        <h3 className="text-align-center"><strong>PLUS</strong> PACKAGE</h3>
                        <div className="package__details">
                          <p className="package__price text-align-center"><small>από</small> 9000€</p>
                          <div className="package__contents">
                            <h4 className="h5 mb-4">όλα του STARTER PACKAGE +<br/> ADVANCED PACKAGE +</h4>
                            <div className="checkmarks checkmarks--theme">
                              <p>Δυνατότητα <strong>B2B</strong> αυτόματος τιμοκατάλογος (χονδρικής πώλησης) με ειδικό login και εκπτωτική πολιτική ανά πελάτη.</p>
                              <p>Έξυπνος <strong>αλγόριθμος</strong> για λειτουργία σχετικών προϊόντων (related products) σύμφωνα με purchase history, collections &amp; tracking.</p>
                              <p>Δυνατότητα συστήματος <strong>upsell / cross sell</strong> σύμφωνα με τις αγορές, UTM tags ή bundle products.</p>
                              <p>Δυνατότητα <strong>segmentation</strong> πελατών σύμφωνα με behaviors, on events ή συγκεκριμένα promotions.</p>
                              <p>Δυνατότητα <strong>Staging / Production</strong> περιβάλλοντος και αυτόματα local backup.</p>
                              <p>Διασύνδεση με οποιοδήποτε <strong>ERP</strong> της αγοράς με Web Services.</p>
                              <p>Διασύνδεση με <strong>συστήματα μεταφορικών εταιριών</strong> (υπολογισμός μεταφορικών, δημιουργία tracking vouchers και tracking links).</p>
                              <p>Oποιοδήποτε <strong>ιδιαίτερο χαρακτηριστικό</strong> απαιτήσει ο πελάτης μετατρέποντας την πλατφόρμα, καλύπτοντας κάθε ιδιαιτερότητα κλάδου ή προϊόντων.</p>
                            </div>
                          </div>
                        </div>
                        <div className="package__cta">
                          <a href="mailto:info@think-plus.gr?subject=Shopify Plus Package" className="btn btn__theme">Επιλογή</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="landing-page__faq">
            <div className="background__theme--dark">
              <SectionHeader
                title="Shopify"
                text="FAQ"
              />
            </div>
            <div className="container medium">
              <div className="row">
                <div className="col-md-6">
                  <Accordion
                    className="accordion--theme"
                    allowZeroExpanded={true}
                  >
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Το Shopify είναι διαθέσιμο για κάθε χώρα;</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Nαι, το Shopify πλέον είναι διαθέσιμο και ιδιαίτερα δημοφιλές στις περισσότερες χώρες του κόσμου, κατακτώντας συνεχώς έδαφος και δημοφιλία.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Απαιτείται να είμαι προγραμματιστής για να δημιουργήσω το δικό μου Shopify;</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Όχι δεν είναι απαραίτητο, καθώς το ίδιο το διαχειριστικό του Shopify σας δίνει την ευελιξία εύκολα και χωρίς ιδιαίτερες γνώσεις να δημιουργήσετε το δικό σας κατάστημα. Φυσικά, αν πραγματικά θέλετε να εκμεταλλευθείτε πλήρως τις δυνατότητες του Shopify και να καλύψετε τις εξειδικευμένες ανάγκες σας, συστήνουμε να εμπιστευθείτε τους ειδικούς της Think Plus.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>To Shopify είναι τελικά μία φθηνή ή ακριβή λύση;</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Εμείς στη Think Plus δεν διακρίνουμε τις λύσεις σε φθηνές ή ακριβές, αλλά σε σωστές ή λανθασμένες. Το Shopify είναι δομημένο βάσει της φιλοσοφίας, “scale up & pay as you go” με αποτέλεσμα να παρέχει εξαιρετικά εργαλεία και αυτοματισμούς στο χρήστη με σημαντικά χαμηλότερο κόστος από οποιοδήποτε άλλο διαχειριστικό. Συνοψίζοντας, λοιπόν το Shopify είναι η κατάλληλη λύση για όποιον θέλει να πετύχει στο κόσμο του ηλεκτρονικού εμπορίου και εμείς στη Think Plus μπορούμε να σας δείξουμε τον τρόπο.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Ποια είναι τα πιο βασικά πλεονεκτήματα του Shopify έναντι των υπολοίπων διαχειριστικών</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>Μερικά από τα πιο σημαντικά επιχειρήματα που απαντούν στην ερώτηση, γιατί Shopify:</p>
                        <ol>
                          <li>
                            <header><strong>Customer History</strong></header>
                            <p>Το πεδίο των πελατών σας στο ίδιο το eshop, σας βοηθάει να μάθετε περισσότερα για τους πελάτες σας, καθώς και τις αγοραστικές τους συνήθειες. Επίσης μέσω αυτού, μπορείτε να εντοπίσετε τόσο τις πληροφορίες επαφών τους, όσο και το ιστορικό παραγγελιών τους με μόλις μία ματιά.</p>
                          </li>
                          <li>
                            <header><strong>Abandoned Cart Recovery</strong></header>
                            <p>Σε περίπτωση ξαφνικής εξόδου των πελατών από το eshop σας χωρίς να ολοκληρώσουν τη συναλλαγή και παρότι είχαν ήδη τοποθετήσει προϊόντα στο καλάθι αγορών τους, με το shopify μπορείτε να τους στείλετε αυτόματα ένα email. Υπολογίζεται ότι 1 από τις 3 παραγγελίες περίπου εγκαταλείπονται κατά τη διάρκεια της διαδικασίας ολοκλήρωσης των αγορών. Αυτή η δυνατότητα σας βοηθά να τραβήξετε πίσω τους πελάτες σας και να αυξήσετε τις πωλήσεις σας.</p>
                          </li>
                          <li>
                            <header><strong>Multi-Language Checkout</strong></header>
                            <p>Με την δυνατότητα επιλογής πλέον των 50 γλωσσών στη σελίδα πληρωμής και καθ’ όλη την περιήγηση, καθώς και την επιλογή από μια πληθώρα τοπικών νομισμάτων, το Shopify σας δίνει τη δυνατότητα να μη περιορίζεται στα εθνικά σας σύνορα, αλλά να έχετε πραγματικά ένα κατάστημα που απευθύνεται σε όλο τον κόσμο. Το δικό σας μέλημα: "καλό προϊόν, ορθό pricing, άριστο performance marketing”.</p>
                          </li>
                          <li>
                            <header><strong>Backend Mobile Application</strong></header>
                            <p>Μέσω της εφαρμογής του Shopify σε κινητά μπορείτε να παρακολουθείτε όλες τις σημαντικές ενημερώσεις για το κατάστημά σας και να το λειτουργείτε πλήρως από την iOS ή Android συσκευή σας. Ελέγξτε τις στατιστικές, τα προϊόντα, τις παραγγελίες, τα στοιχεία των πελατών σας και μεγιστοποιήστε το τζίρο σας.</p>
                          </li>
                        </ol>
                      </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Tι παρέχετε ως εταιρεία στο βασικό πακέτο κατασκευής Shopify;</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <ul className="checkmarks">
                          <p>Κατηγοριοποίηση προϊόντων σε απεριόριστα επίπεδα κατηγοριών και υποκατηγοριών</p>
                          <p>Αναλυτική παρουσίαση κάθε προϊόντος ή υπηρεσίας με απεριόριστο αριθμό φωτογραφιών, κατηγορία, υποκατηγορία, κωδικό, προμηθεύτρια εταιρεία, περιγραφή και τιμή. Οποιαδήποτε άλλη προδιαγραφή μπορεί να συμπεριληφθεί στην περιγραφή.</p>
                          <p>Σύστημα Back Office με Mobile Application του ηλεκτρονικού καταστήματος για την διαχείριση των παραγγελιών και των μελών – πελατών</p>
                          <p>Πλήρη διαχείριση της βάσης δεδομένων των προϊόντων με εύκολο στην χρήση περιβάλλον για προσθήκες, αφαιρέσεις και κάθε είδους τροποποιήσεις</p>
                          <p>Κατασκευή e-shop με όλα τα σύγχρονα φίλτρα πλοήγησης (tags)</p>
                          <p>Διαδικασία εγγραφής μέλους – πελάτη (Sign In), Αναζήτηση (full text) και σύνθετη αναζήτηση &amp; Καλάθι αγορών (Shopping Basket)</p>
                          <p>«Collections» παρουσίασης επιλεγμένων προϊόντων στην κεντρική σελίδα και στην αρχική σελίδα κάθε κατηγορίας προϊόντων</p>
                          <p>Αυτόματη ενημέρωση του διαχειριστή και με email για κάθε παραγγελία</p>
                          <p>Λειτουργία σχετικών προϊόντων (related products)</p>
                          <p>Υπηρεσία αποστολής κωδικού στο email του πελάτη σε περίπτωση απώλειας του κωδικού</p>
                          <p>Υπηρεσία αποστολής email Abandoned Cart Recovery των επιλεγμένων προϊόντων</p>
                          <p>Σύστημα για κουπόνια με δυνατότητα shareable link &amp; δωροκάρτες</p>
                          <p>Δυνατότητα εγγραφής του επισκέπτη για newsletters &amp; email campaigns</p>
                          <p>Οικονομικά στατιστικά σχετικά με την επιχείρησή σας χρησιμοποιώντας τις αναφορές</p>
                          <p>Εταιρική παρουσίαση με πλήρη ανάλυση του ιστορικού της εταιρίας, δραστηριοτήτων, οικονομικών μεγεθών</p>
                          <p>Επιλογή λέξεων κλειδιών &amp; meta description για τις σελίδες κατηγοριών και προϊόντων</p>
                          <p>Επιλογή λέξεων κλειδιών &amp; meta description για τις σελίδες περιεχομένου</p>
                          <p>Δυνατότητα παραμετροποίησης Sitemap</p>
                          <p>Προσαρμογή εξόδων αποστολής και φόρων για όλες τις χώρες</p>
                          <p>Δυνατότητα Sales Channels στο Facebook &amp; Instagram με Tags &amp; Product Catalog</p>
                          <p>Εισαγωγή προϊόντων μέσω αρχείων CSV</p>
                          <p>Ο πελάτης μπορεί να επέμβει άμεσα στην επιλογή προϊόντων στο καλάθι</p>
                          <p>Ο εγγεγραμμένος πελάτης μπορεί να επέμβει στις λεπτομέρειες του λογαριασμού του οποιαδήποτε στιγμή</p>
                          <p>Ο εγγεγραμμένος πελάτης μπορεί να δει το ιστορικό των παραγγελιών του.</p>
                          <p>Πλήρης λίστα από offline τρόπων πληρωμής: Τραπεζική κατάθεση, Μεταφορά χρημάτων μέσω e-banking, Αντικαταβολή κ.τ.λ.</p>
                          <p> Πλήρης υποστήριξη online πληρωμών: Πιστωτικές κάρτες (Viva Payments), Paypal Express</p>
                          <p>Πλήρης HTTPS/SSL υποστήριξη με δωρεάν certificate</p>
                          <p>Προστασία με κωδικό στην πρόσβαση της διαχείρισης</p>
                          <p>Aυτόματο σύστημα fraud analysis στις συναλλαγές με IP Location</p>
                          <p>24/7 Support στα τεχνικά θέματα που αφορούν το Shopify με τηλέφωνο, email και live chat</p>
                          <p>Hosting με απεριόριστο bandwidth και online storage</p>
                        </ul>
                        </AccordionItemPanel>
                    </AccordionItem>
                  </Accordion>
                </div>
                <div className="col-md-6">
                    <Accordion
                      className="accordion--theme"
                      allowZeroExpanded={true}
                    >
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Τελικά, με απλά λόγια γιατί να επιλέξω το Shopify ως λύση για το eshop μου;</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>Για εμάς οι λόγοι είναι πάρα πολλοί. Τεχνικοί και όχι μόνο. Αν θέλαμε όμως να εστιάσουμε σε μη τεχνικά επιχειρήματα, αυτά θα ήταν τα εξής:</p>
                        <ul>
                          <li>γιατί, είναι το πλέον ταχύτερα αναπτυσσόμενο λογισμικό ecommerce παγκοσμίως,</li>
                          <li>γιατί, πίσω του υπάρχει μία τεράστια ιδιωτική εταιρεία με χιλιάδες υπαλλήλους που καθημερινά εξελίσσουν ένα προϊόν, τα οφέλη του οποίου τα καρπώνονται οι χρήστες του. Σε αντίθεση με τα υπόλοιπα open source διαχειριστικά,</li>
                          <li>γιατί, η φιλοσοφία του Shopify είναι πάνω στις πωλήσεις και το marketing και είναι από μόνο του δομημένο έτσι ώστε να μεγιστοποιούνται οι πωλήσεις,</li>
                          <li>γιατί, είναι πάρα πολύ απλό στη χρήση σε αντίθεση με άλλα διαχειριστικά,</li>
                          <li>γιατί, η πρώτη διασύνδεση που έκανε με ecommerce το facebook &amp; το instagram ήταν με shopify, αυτό κάτι λέει…</li>
                          <li>γιατί, αποδεδειγμένα έχει eshops που κάνουν δισεκατομμύρια τζίρο (Kylie Jenner),</li>
                          <li>γιατί, παρέχει το καλύτερο server στο κόσμο και τρομερά επίπεδα ασφάλειας και ταχύτητας,</li>
                          <li>και πολλά άλλα που θα χαρούμε να σας πούμε από κοντά, στη Think Plus.</li>
                        </ul>
                      </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Μπορεί το shopify μου να διασυδενθεί με το skroutz;</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Φυσικά και μπορεί. Ένα από τα πιο σημαντικά επιχειρήματα για το shopify είναι το app store που διαθέτει, ακριβώς όπως το smartphone σας. Εκεί λοιπόν θα βρείτε εκατοντάδες applications, δωρεάν και μη, τα οποία εύκολα μπορείτε να εγκαταστήσετε στο shopify σας και να δείτε τις πωλήσεις σας να αυξάνονται. Ένα από αυτά είναι το application για το Skroutz που είναι <a href="https://apps.shopify.com/export-product-skroutz-xml-feed" target="_blank" title="Shopify Skroutz xml feed app">απολύτως δωρεάν</a> και το έχει φτιάξει η ομάδα της Think Plus.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Μπορεί το shopify μου να διασυδενθεί με το BestPrice;</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Φυσικά και μπορεί. Ένα από τα πιο σημαντικά επιχειρήματα για το shopify είναι το app store που διαθέτει ακριβώς όπως το smartphone σας. Εκεί λοιπόν θα βρείτε εκατοντάδες applications, δωρεάν και μη, τα οποία εύκολα μπορείτε να εγκαταστήσετε στο shopify σας και να δείτε τις πωλήσεις σας να αυξάνονται. Ένα από αυτά είναι το application για το BestPrice που είναι <a href="https://apps.shopify.com/export-product-best-price-xml-feed" target="_blank" title="Shopify Best Price xml feed app">απολύτως δωρεάν</a> και το έχει φτιάξει η ομάδα της Think Plus.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Μπορεί το shopify μου να διασυδενθεί με το Glami;</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel><p>Φυσικά και μπορεί. Ένα από τα πιο σημαντικά επιχειρήματα για το shopify είναι το app store που διαθέτει ακριβώς όπως το smartphone σας. Εκεί λοιπόν θα βρείτε εκατοντάδες applications, δωρεάν και μη, τα οποία εύκολα μπορείτε να εγκαταστήσετε στο shopify σας και να δείτε τις πωλήσεις σας να αυξάνονται. Ένα από αυτά είναι το application για το Glami που είναι απολύτως δωρεάν και το έχει φτιάξει η ομάδα της Think Plus.</p></AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton><span className="accordion__icon" aria-hidden="true"></span>Γιατί να επιλέξω τη Think Plus για το Shopify μου;</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>Αυτή φυσικά είναι μια ερώτηση που θα επιθυμούσαμε να σας την απαντήσουμε από κοντά…Αλλά αν έπρεπε να επιλέξουμε τους τρεις κυριότερους λόγους, αυτοί θα ήταν οι εξής:</p>
                        <ol>
                          <li>Είμαστε η εταιρεία με τη μεγαλύτερη εμπειρία στην Ελλάδα στη δημιουργία shopify.</li>
                          <li>Είμαστε η μοναδική εταιρεία που έχει φτιάξει <a href="https://apps.shopify.com/partners/think-plus1" target="_blank" title="Shopify Experts Greece - Think Plus">applications για το app store του shopify και με άκρως θετικά reviews</a>.</li>
                          <li>Είμαστε ο στρατηγικός σας συνεργάτης στο κόσμο του e commerce καθώς πέραν του shopify σας, μπορούμε να σας παρέχουμε όλες τις αναγκαίες υπηρεσίες για να πετύχετε σ’ αυτόν το τόσο ανταγωνιστικό χώρο.</li>
                        </ol>
                      </AccordionItemPanel>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </div>
          </section>
          <Partnerships />
          <OurPartners headerTitle="ΠΕΛΑΤΕΣ" />
          <Testimonials classname="background__theme--dark" />
          <section className="landing-page__case-studies background__theme">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6 order-2 order-md-0">
                  <div className="case-study__content text-align-center">
                    <h2 className="h1">AEK FC</h2>
										<h3 className="h4">#FLYINGHIGH</h3>
                    <p>Το πιο ποδοσφαιρικό eshop! ΑΕΚ και Think Plus, παίζουν μαζί στο γήπεδο του ηλεκτρονικού εμπορίου και σκοράρουν αμέτρητα γκολ στις πωλήσεις αγαπημένων προϊόντων!</p>
                  </div>
                </div>
                <div className="col-md-6 order-1 order-md-0 background__white background-bleed__right">
                  <div className="case-study__photo text-align-right">
                    <GatsbyImage
                      image={data.caseStudy_aek.childImageSharp.gatsbyImageData}
                      alt="AEK FC - Think Plus | Shopify Eshop" />
                    <a href="https://shop.aekfc.gr/" title="AEK FC - Shopify shop" className="btn--more" target="_blank">View site <span>&rarr;</span></a>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-md-6 background__white background-bleed__left">
                  <div className="case-study__photo text-align-right">
                    <GatsbyImage
                      image={data.caseStudy_bioaroma.childImageSharp.gatsbyImageData}
                      alt="Bioaroma - Think Plus | Shopify Eshop" />
                    <a href="https://bioaromacrete.com/" title="Bioaroma - Shopify shop" className="btn--more" target="_blank">View site <span>&rarr;</span></a>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="case-study__content text-align-center">
                    <h2 className="h1">Bioaroma Crete</h2>
										<h3 className="h4">«Βιο»λογικά θα θέλετε και εσείς ένα τέτοιο e-shop!</h3>
                    <p>«Βιο»λογικά θα θέλετε και εσείς ένα τέτοιο e-shop! Tο e-shop της BIOAROMA Crete, πάνω στην πλατφόρμα του Shopify, αποτελεί ένα από τα πλέον σύγχρονα και ανταγωνιστικά e-shop προσφέροντας μια αξέχαστη εμπειρία περιήγησης και αγορών! </p>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-md-6 order-2 order-md-0">
                  <div className="case-study__content text-align-center">
                    <h2 className="h1">Καφεκοπτεία Λουμίδη</h2>
										<h3 className="h4">Ελληνική οικογενειακή επιχείρηση από το 1920</h3>
                    <p>Το νέο eshop των Καφεκοπτείων Λουμίδη! Άρωμα καφέ, σε ένα νέο μοναδικό shopify e-shop που ανταποκρίνεται στις υψηλές απαιτήσεις της εποχής και φέρνει τη γεύση της παράδοσης ένα κλικ πιο κοντά σας!</p>
                  </div>
                </div>
                <div className="col-md-6 order-1 order-md-0 background__white background-bleed__right">
                  <div className="case-study__photo text-align-right">
                    <GatsbyImage
                      image={data.caseStudy_loumidis.childImageSharp.gatsbyImageData}
                      alt="Καφεκοπτεία Λουμίδης - Think Plus | Shopify Eshop " />
                    <a href="https://www.kafekopteialoumidi.gr/" title="Loumidis - Shopify shop" className="btn--more" target="_blank">View site <span>&rarr;</span></a>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-md-6 background__white background-bleed__left">
                  <div className="case-study__photo text-align-right">
                    <GatsbyImage
                      image={data.caseStudy_apoella.childImageSharp.gatsbyImageData}
                      alt="Apoella - Think Plus | Shopify Eshop" />
                    <a href="https://apoella.com/" title="Apoella - Shopify shop" className="btn--more" target="_blank">View site <span>&rarr;</span></a>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="case-study__content text-align-center">
                    <h2 className="h1">Apoella</h2>
                    <h3 className="h4">apoella.com apo τη Τhink Plus!</h3>
                    <p>Η Apoella έχοντας ήδη κατακτήσει μερικά από τα καλύτερα ξενοδοχεία πολυτελείας σε Ελλάδα και εξωτερικό, και διαθέτοντας ένα εκλεκτό πελατολόγιο στο δίκτυο των concept stores κατακτά και τον κόσμο του e-commerce με ένα custom design, shopify e-shop!</p>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-md-6 order-2 order-md-0">
                  <div className="case-study__content text-align-center">
                    <h2 className="h1">DE-Sunglasses</h2>
										<h3 className="h4">Where design meets eyewear</h3>
                    <p>Το DE-SUNGLASSES είναι ένα από τα πλέον ανερχόμενα ηλεκτρονικά καταστήματα στο χώρο των οπτικών με πρωτοφανή τζίρο εξαγωγών, ενώ διαθέτει ένα πλήρες και ενημερωμένο κατάλογο από γυαλιά ηλίου για όλα τα στιλ και τα γούστα στις καλύτερες τιμές της αγοράς.</p>
                  </div>
                </div>
                <div className="col-md-6 order-1 order-md-0 background__white background-bleed__right">
                  <div className="case-study__photo text-align-right">
                    <GatsbyImage
                      image={data.caseStudy_desunglasses.childImageSharp.gatsbyImageData}
                      alt="DE-Sunglasses - Think Plus | Shopify Eshop" />
                    <a href="https://www.de-sunglasses.com/" title="DE-Sunglasses - Shopify shop" className="btn--more" target="_blank">View site <span>&rarr;</span></a>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <WhyThinkPlus />
          <ContactForm />
        </article>
      </Layout>
    </>;
}

export default pageEshopshoppify
